var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stack-item tracking"},[_c('h3',[_vm._v(_vm._s(_vm.$t('SHARE_ORDER.path.tracking_number')))]),_c('h4',[_vm._v(_vm._s(_vm.trackingNumber))])])}
var staticRenderFns = []

export { render, staticRenderFns }